import type {
  PagePermissionsResponse,
  PagePermissionsUpdateRequest,
} from "@/interface/PagePermissions";
import { logger } from "@/utils/logger";

import { axiosInstance } from "./axiosInstance";

export const getPagePermissions = async (): Promise<PagePermissionsResponse | null> => {
  try {
    const response = await axiosInstance.get("/api/v1/page-permissions");
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null; // No custom config -- use defaults
    }
    logger.error("Error fetching page permissions", {
      error,
      context: "getPagePermissions",
      endpoint: "/api/v1/page-permissions",
    });
    throw error;
  }
};

export const updatePagePermissions = async (
  payload: PagePermissionsUpdateRequest,
): Promise<PagePermissionsResponse> => {
  try {
    const response = await axiosInstance.put("/api/v1/page-permissions", payload);
    return response.data;
  } catch (error) {
    logger.error("Error updating page permissions", {
      error,
      context: "updatePagePermissions",
      endpoint: "/api/v1/page-permissions",
    });
    throw error;
  }
};
